import { render, staticRenderFns } from "./userTxt.vue?vue&type=template&id=e384814c&scoped=true&"
import script from "./userTxt.vue?vue&type=script&lang=js&"
export * from "./userTxt.vue?vue&type=script&lang=js&"
import style0 from "./userTxt.vue?vue&type=style&index=0&id=e384814c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e384814c",
  null
  
)

export default component.exports